
































import { UserCreditData } from '@/pages/home/types';
import {
  defineComponent,
  PropType,
  computed,
  onMounted,
} from '@vue/composition-api';
import { CouponTypeEnum } from '@/api/coupon/types';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { TP_HOME_FINANCE_CARD_COUPON_INFO } from '@/pages/home/tianqi';
import { getUserHomeScene } from '@/pages/home/utils';

/**
 * 首页优惠券模块信息
 */
export default defineComponent({
  name: 'CouponInfo',
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    className: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    /** 优惠券类型 */
    const couponType = computed(() => props.userCreditData.freeCouponType);
    /** 优惠券金额 */
    const amount = computed(() => props.userCreditData.couponNameMoney);
    /** 优惠券时间 */
    const day = computed(() => props.userCreditData.couponNameDay);

    onMounted(() => {
      const scene = getUserHomeScene(props.userCreditData);
      /** 优惠券曝光埋点 */
      ubtSetupModuleExpose(TP_HOME_FINANCE_CARD_COUPON_INFO, {
        scene,
        preCreditUserSource: props.userCreditData.preCreditUserSource,
        normalPreCreditModel: props.userCreditData.normalPreCreditModel,
        couponType: props.userCreditData.freeCouponType,
      });
    });

    return {
      couponType,
      amount,
      day,
      CouponTypeEnum,
    };
  },
});
